import wModal from './w-modal.vue';

import { installer } from '#util';

export const Modal = { install: installer([wModal]) };
export { wModal };
